import { type FC, type ReactNode } from 'react';
import isNil from 'lodash/isNil';
// Import Types
import type { FilterChip } from 'types';
// Import UI Components
import { Divider } from '@geneui/components';
// Import Components
import { FilterChips } from '../FilterChips';
// Import Styles
import styles from './listHeader.module.scss';

export interface ListHeaderTitleProps {
    title: ReactNode;
    chips?: FilterChip[];
    onChipRemove?: (index: number) => void;
}

/**
 * Left part of the compact list header: the list title, a vertical divider and the active filter chips.
 * Rendered into gene-ui `ComboTable`'s `name` slot.
 */
export const ListHeaderTitle: FC<ListHeaderTitleProps> = ({ title, chips = [], onChipRemove }) => {
    const hasChips = chips.length > 0 && !isNil(onChipRemove);

    return (
        <div className={styles.listHeaderTitle}>
            <span className={styles.listHeaderTitleText}>{title}</span>
            {hasChips ? (
                <>
                    <Divider type="vertical" withSpace={false} className={styles.listHeaderTitleDivider} />
                    <FilterChips chips={chips} onChipRemove={onChipRemove} />
                </>
            ) : null}
        </div>
    );
};
